<script setup lang="ts">
import { ref,reactive,onMounted } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import config from "../../config.js";
import { getFieldValue } from "../../plugins/utility";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    user:{
      type:Object,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listAuditCheckRef = ref();
const listDeliveryConfirmationRef = ref();
const auditCheckOptionFields = reactive({
  'spapp_menu': config.SPAPP_MENU['監査チェック'],
  'page_size' : 30,
});
const deliveryConfirmationOptionFields = reactive({
  'spapp_menu': config.SPAPP_MENU['納品確認'],
  'page_size' : 30,
});
const auditCheckFields = ref([
  {field_name: '来院日', field_key: 'prescript_date', width: '30%', align: 'text-left'},
  {field_name: '患者名', field_key: 'patient_profile.patient_kanji_name', width: '40%', align: 'text-center'},
  {field_name: '担当者', field_key: 'audit_staff_name', width: '30%', align: 'text-center'}
]);

const deliveryConfirmationFields = ref([
  {field_name: '納品日', field_key: 'delivery_confirm_datetime', width: '30%', align: 'text-center'},
  {field_name: '取引先', field_key: 'order_target', width: '40%', align: 'text-left'},
  {field_name: '担当者', field_key: 'username', width: '30%', align: 'text-center'}
]);

const historyActiveTab = ref(0);
const historyActiveTabs = [
  {id:0,tab_name:"監査チェック"},
  {id:1,tab_name:"納品確認"},
]

onMounted(() => {
});

</script>

<style scoped>
table td {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
.active {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(242 140 31 / var(--tw-border-opacity));
  border-bottom-width: 4px;
}
.active > svg {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
</style>
<template>
<div ref="element" class="relative">
  <div class="w-full">
    <div class="w-full mt-1 mb-5">
      <div class="bg-white border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
              <li class="w-1/2" v-for="tab in historyActiveTabs" :key="tab.id">
                  <a href="javascript:void(0)" @click="historyActiveTab = tab.id" :class="(historyActiveTab == tab.id ? 'active ' : '') + 'flex flex-col items-center justify-center pt-2 pb-2 border-b-4 border-gray-300 rounded-t-lg group'">
                      <div>
                        <img v-if="tab.id == 0 && historyActiveTab == tab.id" class="h-12 w-12" src="../../../public/spapp/icon/icon_audit_check.svg">
                        <img v-else-if="tab.id == 0 && historyActiveTab != tab.id" class="h-12 w-12" src="../../../public/spapp/icon/icon_audit_check_off.svg">
                        <img v-else-if="tab.id == 1 && historyActiveTab == tab.id" class="h-12 w-12" src="../../../public/spapp/icon/icon_delivery_confirmation.svg">
                        <img v-else class="h-12 w-12" src="../../../public/spapp/icon/icon_delivery_confirmation_off.svg">
                      </div>
                      <div>{{ tab.tab_name }}</div>
                  </a>
              </li>
          </ul>
      </div>
    </div>
    <div v-if="historyActiveTab == 0">
      <custom-list
        ref="listAuditCheckRef"
        :table-fields="auditCheckFields"
        :api-url="apis.pharmacy_check_history_list"
        :option-fields="auditCheckOptionFields"
        height="80vh"
        font-size="1.0em"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in auditCheckFields" :style="'width:' + field.width" :class="field.align + ' px-2 py-4'">
          <div :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
      </template>
      </custom-list>
    </div>
    <div v-else class="p-2">
      <custom-list
        ref="listDeliveryConfirmationRef"
        :table-fields="deliveryConfirmationFields"
        :api-url="apis.pharmacy_check_history_list"
        :option-fields="deliveryConfirmationOptionFields"
        height="80vh"
        font-size="1.0em"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in deliveryConfirmationFields" :style="'width:' + field.width" :class="field.align + ' px-2 py-4'">
          <div v-if="field.field_key == 'delivery_confirm_datetime'" class="text-center" v-html="getFieldValue(slotProps.item,field.field_key).replace(' ','</br>')">
          </div>
          <div v-else>
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
      </template>
      </custom-list>
    </div>
  </div>
</div>
</template>

